export class documentModel {
    "identificationDoc"			: string = "";
    "ownershipDoc"			: string = "";
    "authorizationDoc"			: string = "";
    "originalFileName" : string;
    "netAmount" : number;
    
  }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/documentUpload/doc.model.ts